import { useCallback } from 'react'
import { resetCrudSelection } from '@/atoms'
import { useDeleteSimulationModal } from '../../../../modals/DeleteSimulationModal'

export function useActions() {
  const { show: showDeleteSimulationModal } = useDeleteSimulationModal()

  const onDelete = useCallback(() => {
    showDeleteSimulationModal()
  }, [showDeleteSimulationModal])

  const onReset = useCallback(() => {
    resetCrudSelection('simulations')
  }, [resetCrudSelection])

  return {
    onDelete,
    onReset,
  }
}
